﻿var Vendd = (function (Vendd) {
    'use strict';
    var pending = false;

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionState, Vendd.User, function (envelope) {
        if (pending === true) {
            return false;
        };

        function onSuccess(response) {
            return Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionStateSuccess(response));
        };

        function onFailure(response) {
            return Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionStateSuccess({ IsNewSession: true }));
        };

        var options = {
            method: 'POST',
            url: 'api/Tools/GetSessionStatus',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        pending = true;

        Vendd.Service.call(options);

        return true;
     });

    return Vendd;

})(Vendd || {});
